import PropTypes from 'prop-types';
import { Tooltip } from 'antd';
import { LoadingOutlined, CheckCircleFilled } from '@ant-design/icons';
import styles from './AiAssist.module.scss';

/** Petite icône « étincelles » (IA), hérite de la couleur courante. */
function SparkleIcon({ className }) {
    return (
        <svg className={className} viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor" aria-hidden="true">
            <path d="M12 2.5l1.6 4.3a4 4 0 0 0 2.36 2.36L20.5 11l-4.04 1.84a4 4 0 0 0-2.36 2.36L12 19.5l-1.6-4.3a4 4 0 0 0-2.36-2.36L4 11l4.04-1.84A4 4 0 0 0 10.4 6.8L12 2.5z" />
            <path d="M5 3l.62 1.68L7.3 5.3l-1.68.62L5 7.6l-.62-1.68L2.7 5.3l1.68-.62L5 3z" opacity=".7" />
        </svg>
    );
}
SparkleIcon.propTypes = { className: PropTypes.string };

/**
 * Bouton-icône à placer dans le `suffix` de l'Input « nom ».
 * Au clic, déclenche l'analyse de l'intitulé courant.
 */
export function AiNameTrigger({ loading, disabled, onClick }) {
    return (
        <Tooltip title="Reformuler l'intitulé avec l'IA">
            <button
                type="button"
                tabIndex={-1}
                className={styles.nameTriggerBtn}
                disabled={disabled || loading}
                aria-label="Reformuler l'intitulé avec l'IA"
                onMouseDown={(e) => e.preventDefault()}
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); onClick(); }}
            >
                {loading ? <LoadingOutlined /> : <SparkleIcon />}
            </button>
        </Tooltip>
    );
}
AiNameTrigger.propTypes = {
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
};

/**
 * Panneau de résultat à placer juste sous le champ « nom ».
 * Affiche la proposition, une confirmation, ou un message d'indisponibilité.
 */
export function AiNamePanel({ status, proposal, onApply, onReset }) {
    if (status === 'idle') return null;

    if (status === 'short') {
        return <div className={styles.nameHint}>Saisissez d&apos;abord un intitulé plus complet.</div>;
    }

    if (status === 'error') {
        return <div className={styles.nameHint}>Suggestion indisponible pour le moment. Réessayez.</div>;
    }

    if (status === 'pertinent') {
        return (
            <div className={styles.nameOk}>
                <CheckCircleFilled /> Votre intitulé est déjà clair et bien formulé.
            </div>
        );
    }

    // status === 'proposal'
    return (
        <div className={styles.suggestRow}>
            <div className={styles.suggestChip}>
                <SparkleIcon className={styles.bulb} />
                <span className={styles.suggestText}>{proposal}</span>
                <button type="button" className={styles.applyBtn} onClick={() => onApply(proposal)}>
                    Appliquer
                </button>
                <button type="button" className={styles.dismissBtn} onClick={onReset}>
                    Ignorer
                </button>
            </div>
        </div>
    );
}
AiNamePanel.propTypes = {
    status: PropTypes.oneOf(['idle', 'short', 'proposal', 'pertinent', 'error']).isRequired,
    proposal: PropTypes.string,
    onApply: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
};
